import { authApi } from "./";

/**
 *
 * @returns array of file names
 */
export const getImage = async () => {
  const response = await authApi.get("image/get", {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (response) {
    return response.data.images;
  }
  return [];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const uploadImage = async (
  file: File,
  detailed: boolean,
  overrideFilename: string | undefined = undefined
): Promise<any> => {
  const fd = new FormData();
  fd.append("file", file);
  // Always send filename — either override or original
  fd.append("filename", overrideFilename ?? file.name);

  fd.append("isDetailed", String(detailed)); // "true" or "false"

  const response = await authApi.post("image/upload", fd);

  return response;
};
